import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import MessagingCopy from '../messaging/MessagingCopy';
import { Data } from '../signup-data/DATA';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import { useSignupData } from '../signup-data/useSignupData';
import { useRegisteredLeads } from '../standalone-cms-partner/useRegisteredLeads';
import { InputStyles } from '../views-components/TextInput.styles';
import { BaseView } from './BaseView';
import { getStepConfig } from './getStepConfig';
import { Step } from './Step';
import { useView } from './useView';

const CmsPartnerCompanyDomainAndNameView = () => {
  const stepKey = Step.CmsPartnerCompanyDomainAndName;
  const {
    submit
  } = useView({
    stepKey
  });
  const {
    data: companyDomain
  } = useSignupData(Data.CompanyDomain);
  const {
    leads,
    onCompanyDomainChange
  } = useRegisteredLeads();
  const stepConfig = getStepConfig(Step.CmsPartnerCompanyDomainAndName);

  const helperText = /*#__PURE__*/_jsx(MessagingCopy, {
    message: `views.${stepKey}.helperText`
  });

  if (!stepConfig) {
    return null;
  }

  return /*#__PURE__*/_jsxs(BaseView, {
    helperText: helperText,
    children: [/*#__PURE__*/_jsx(InputStyles, {
      industryStyle: true,
      success: Boolean(companyDomain),
      children: /*#__PURE__*/_jsx(UISelect, {
        className: "CompanyDomainDropdown",
        "data-selenium": "CompanyDomainDropdown",
        options: leads,
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `data.${Step.CompanyDomain}.label`
        }),
        value: companyDomain,
        onChange: onCompanyDomainChange
      })
    }), /*#__PURE__*/_jsx(SignupDataInputForm, {
      dataKey: Data.CompanyName,
      inputMode: 'text',
      submit: submit
    }, stepKey)]
  });
};

export default CmsPartnerCompanyDomainAndNameView;